import React from 'react';
import DatePopup from '../Base';
import Styled from './style';

const Index = (props) => {
  return <DatePopup {...props} Styled={Styled} />;
};

export default Index;